import {
  FilterType,
  buildMandatoryProcessTasksFilter,
  useMandatoryProcessTasks,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

export const taskNameFilter = (source: ReturnType<typeof useMandatoryProcessTasks>) =>
  buildMandatoryProcessTasksFilter(source, {
    type: FilterType.String,
    categories: [
      {
        kind: 'SearchFilter',
        operation: 'contains',
      },
    ],
    identifier: 'processesTaskList.taskNameFilter',
    path: 'name',
    title: i18n.t('processes.process.overview.tasks_table.name'),
  })
